/**
 * Video Overlays Module for History Single Decade
 *
 * @description
 * <p>Handles video overlays specifically for pages with the "history-single-decade" body class.</p>
 * <p>On page load, adds click events to all .video-btn elements, directly embedding and playing the video instead of opening a popup.</p>
 * <p>Self-initializes when you include this module.</p>
 *
 * @module videosHistory
 *
 * @namespace site.videosHistory
 */
(function (site, $) {
  "use strict";
  var currentVideoContainer = null;

  function init() {
    if (!$("body").hasClass("history-single-decade")) {
      return;
    }

    $(".watch-video-btn, .play-mob-btn").on("click", function (event) {
      event.preventDefault();
      var galleryWrapper = $(this).closest(".history-decade-gallery-wrapper");
      var videoContainer = galleryWrapper.find(".video-btn-history");
      var innerWrap = galleryWrapper.find(".history-gallery-inner-wrap");

      if (currentVideoContainer && currentVideoContainer !== videoContainer) {
        closeVideo(
          currentVideoContainer.closest(".history-decade-gallery-wrapper"),
          currentVideoContainer
        );
      }

      currentVideoContainer = videoContainer;

      showVideo(galleryWrapper, videoContainer, innerWrap);
    });


    $(document).on(
      "click",
      ".video-btn-history .close-video-hist",
      function (event) {
        event.preventDefault();
        var videoContainer = $(this).closest(".video-btn-history");
        var galleryWrapper = videoContainer.closest(
          ".history-decade-gallery-wrapper"
        );
        var innerWrap = galleryWrapper.find(".history-gallery-inner-wrap");
        closeVideo(galleryWrapper, videoContainer, innerWrap);
      }
    );

    document.addEventListener("fullscreenchange", function () {
      console.log("Fullscreen mode changed!!!");

      if (currentVideoContainer) {
        var galleryWrapper = currentVideoContainer.closest(
          ".history-decade-gallery-wrapper"
        );

        if (galleryWrapper.length > 0) {
          var galleryWrapperId = galleryWrapper.attr("id");
          var element = document.getElementById(galleryWrapperId);

          if (element) {
            setTimeout(function () {
              element.scrollIntoView();
            }, 100);
          }
        }
      }
    });
  }


  function showVideo(galleryWrapper, videoContainer, innerWrap) {
    var vidVimeoId = videoContainer.attr("data-vimeo-vidid");
    var videoPlayer =
      '<iframe src="https://player.vimeo.com/video/' +
      vidVimeoId +
      '?h=5707ca4be6&form=html&autoplay=1&transparent=0" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';

    var closeButton =
      '<span class="close-video-hist"><img src="/themes/custom/universal/images/close-video.svg" alt="Close Video"></span>';

    videoContainer.html(closeButton + videoPlayer);
    videoContainer.addClass("active");
    galleryWrapper.addClass("active");

    if (innerWrap) {
      innerWrap.addClass("active");
    }
  }

  function closeVideo(galleryWrapper, videoContainer, innerWrap) {
    var iframe = videoContainer.find("iframe");
    iframe.attr("src", "");

    videoContainer.removeClass("active");
    galleryWrapper.removeClass("active");

    if (innerWrap) {
      innerWrap.removeClass("active");
    }
  }

  site.videosHistory = {};

  $(function () {
    init();
  });
})(window.site || {}, jQuery);
